var React = require('react');

function Trend (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m58.564 46.77c1.027 1.581 1.085 3.181 0.175 4.803-0.907 1.618-2.308 2.427-4.205 2.427h-49.067c-1.896 0-3.299-0.809-4.209-2.427-0.908-1.622-0.847-3.222 0.18-4.803l24.533-38.637c0.948-1.422 2.291-2.133 4.03-2.133 1.738 0 3.081 0.711 4.029 2.133l24.534 38.637z","fillRule":"nonzero"}));
}

Trend.defaultProps = {"clipRule":"evenodd","fillRule":"evenodd","strokeLinejoin":"round","strokeMiterlimit":"2","version":"1.1","viewBox":"0 0 60 60","xmlSpace":"preserve"};

module.exports = Trend;

Trend.default = Trend;
